import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { login, signInWithGoogleAsAdmin } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !password) {
      setError('Please fill out this field.');
      return;
    }
    
    try {
      setError('');
      setLoading(true);
      await login(email, password);
      // Will be redirected to /admin by the auth system if user has admin role
      navigate('/admin');
    } catch (error) {
      setError('Failed to log in: ' + error.message);
    }
    
    setLoading(false);
  };

  const handleGoogleLogin = async () => {
    try {
      setError('');
      setLoading(true);
      await signInWithGoogleAsAdmin();
      navigate('/admin');
    } catch (error) {
      setError('Failed to sign in with Google: ' + error.message);
    }
    setLoading(false);
  };

  return (
    <div className="modern-auth-container">
      <div className="modern-auth-card">
        <div className="auth-logo-section">
          <div className="auth-logo">
            <img 
              src="/logo.png" 
              alt="Paradise Landscaping Logo" 
              className="auth-logo-image"
            />
          </div>
          <h1 className="modern-auth-title">Admin Portal</h1>
          <p className="auth-subtitle">Sign in to your admin account</p>
        </div>
        
        {error && (
          <div className="error-message">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="modern-form-group">
            <label className="modern-form-label">Admin Email Address</label>
            <div className="input-with-icon">
              <span className="input-icon">✉</span>
              <input
                type="email"
                className="modern-form-input"
                placeholder="Enter your admin email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="modern-form-group">
            <label className="modern-form-label">Password</label>
            <div className="input-with-icon">
              <span className="input-icon">🔒</span>
              <input
                type={showPassword ? "text" : "password"}
                className="modern-form-input"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? '👁️' : '👁️‍🗨️'}
              </button>
            </div>
          </div>

          <div className="auth-options">
            <label className="checkbox-container">
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
              />
              <span className="checkmark"></span>
              Remember me
            </label>
            <Link to="/admin/forgot-password" className="forgot-password-link">
              Forgot password?
            </Link>
          </div>

          <button 
            type="submit" 
            className="modern-btn-primary admin-btn"
            disabled={loading}
          >
            {loading ? 'Signing In...' : 'Admin Sign In'}
          </button>
        </form>

        <div className="auth-divider">
          <span>OR CONTINUE WITH</span>
        </div>

        <button 
          onClick={handleGoogleLogin}
          className="google-btn"
          disabled={loading}
        >
          <span className="google-icon">🔍</span>
          Continue with Google
        </button>

        <div className="auth-footer">
          Need admin account? <Link to="/admin/signup" className="auth-link">Register Here</Link>
        </div>

        <div className="auth-footer" style={{ marginTop: '1rem', paddingTop: '1rem', borderTop: '1px solid #e5e7eb' }}>
          Customer portal: <Link to="/login" className="auth-link">Customer Login</Link>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
